// extracted by mini-css-extract-plugin
export default {"backButton":"MapPage_backButton__UMEL+","filterToggle":"MapPage_filterToggle__P9sGI","filterPanel":"MapPage_filterPanel__45Tvt","resetButton":"MapPage_resetButton__LJRpB"};